module.exports = __webpack_public_path__ + "static/img/loading.35570e8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/message/loading.gif
// module id = 6xQS
// module chunks = 52